import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentText} from '@tisa-group/models';

@Component({
  selector: 'tisa-text',
  imports: [CommonModule],
  templateUrl: './text.component.html',
  styleUrl: './text.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextComponent {
  readonly component = input<UmpireComponentText | undefined>();
}
